import { render, staticRenderFns } from "./shops-admin-layout.vue?vue&type=template&id=5c8c7caa&scoped=true"
import script from "./shops-admin-layout.vue?vue&type=script&lang=js"
export * from "./shops-admin-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8c7caa",
  null
  
)

export default component.exports